// timeToMidnight - вычисляет время до полуночи сегодняшнего дня
export function timeToMidnight() {
    let time = new Date();
    time.setHours(0, 0, 0, 0);
    time.setDate(time.getDate() + 1);

    return time;
}
